import { GET_NAME_CARD, POST_NAME_CARD, PUT_NAME_CARD, DELETE_NAME_CARD } from '../type'

const initialState = {
  listNameCard: [],
  countNameCard: 0
}

const nameCard = (state = initialState, action) => {
  switch (action.type) {
    case GET_NAME_CARD:
      return {
        ...state,
        listNameCard: action.data.data,
        countNameCard: action.data.count
      }
    case POST_NAME_CARD:
      return {
        ...state,
        listNameCard: [...state.listNameCard, action.data]
      }
    case PUT_NAME_CARD:
      return {
        ...state,
        listNameCard: state.listNameCard.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_NAME_CARD:
      return {
        ...state,
        listNameCard: state.listNameCard.filter(
          (item) => item._id !== action.data._id
        )
      }

    default:
      return state
  }
}

export default nameCard